import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import { CreateDesignationService, UpdateDesignationService } from '../../../services/DesignationService'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { ButtonFilledAutoWidth } from '../../../components/button'
import { CreateWatiService, UpdateWatiService } from '../../../services/WatiService'
import { message } from 'antd'

function WatiCE() {
 
  const [data,setdata] = useState({name:'',phone:'',message:'',allInfo:''});  
  const [error,seterror] = useState({name:'',phone:'',message:'',allInfo:''}); 
  
  const {state} = useLocation();
  const navigate = useNavigate();

  // const {id,department_name} = state;


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      setdata({...data,...state})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
  
        if(state?._id === undefined || state?._id === null){
        const response = await CreateWatiService(data)
        if (response.status === 201) {
          resetform()
          toast.success('Wati Message Created Successfully')
        }   
      }else{
        let send_data = {...data}
        send_data["id"] = state?._id
        const response = await UpdateWatiService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Wati Message Updated Successfully')
        }   
  }
  }

  function resetform(){
    setdata({name:'',phone:'',message:'',allInfo:''})
    seterror({name:'',phone:'',message:'',allInfo:''})
  }

  

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      

        <h6 className='font-bold'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Wait Message</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Wait Message</b> for your reference.</h6>
     
       <TextInput 
            label={'Name'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your Designation name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

        <TextInput 
            label={'Phone'}  
            variant="standard"
            name="phone"
            type="text"
            error={error.phone}
            value={data.phone}
            handlechange={handlechange}
            placeholder="Enter your Designation name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

         <TextAreaInput1 
            label={'Message'}  
            variant="standard"
            name="message"
            type="text"
            error={error.message}
            value={data.message}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          <TextAreaInput1 
            label={'All Info'}  
            variant="standard"
            name="allInfo"
            type="text"
            error={error.allInfo}
            value={data.allInfo}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>     

<div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE WATI" : "ADD WATI"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default WatiCE